import { useQuery } from "react-query";
import { cacheKey } from "./shared";
import { getGenres } from "frontend/src/api/genres/get-many";
export var useGenres = function () {
    var _a = useQuery(cacheKey, function () { return getGenres(); }), data = _a.data, isFetching = _a.isFetching;
    return { genres: data, isFetching: isFetching };
};
